const VISIBILITY_CODE_KEYS_MAP = {
  vc: "visibility_code",
  vc_eq: "visibility_code_exact"
}

export const getVisibilityOptionFromParams = () => {
  const params = new URLSearchParams(window.location.search)
  const key = params.get("vc") ? "vc" : params.get("vc_eq") ? "vc_eq" : null

  if (key) {
    return {
      [VISIBILITY_CODE_KEYS_MAP[key]]: params.get(key)
    }
  }

  return null
}
